// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SecondaryPanel__panel___3jEfa{position:relative}.SecondaryPanel__flyoutPopover___2J0pR{transform:translateY(0)!important}.SecondaryPanel__flyoutPopover___2J0pR{left:44px;padding:0}.SecondaryPanel__separator___3m7Lc{margin:8px 12px;opacity:1}.SecondaryPanel__desktopSeparator___1mZtO{border-top:1px solid var(--spectrum-global-color-gray-200)}.SecondaryPanel__mobileSeparator___2p9ru{border-left:1px solid var(--spectrum-global-color-gray-200)}", ""]);
// Exports
exports.locals = {
	"panel": "SecondaryPanel__panel___3jEfa",
	"flyoutPopover": "SecondaryPanel__flyoutPopover___2J0pR",
	"separator": "SecondaryPanel__separator___3m7Lc",
	"desktopSeparator": "SecondaryPanel__desktopSeparator___1mZtO",
	"mobileSeparator": "SecondaryPanel__mobileSeparator___2p9ru"
};
module.exports = exports;
